import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/analytics'
import 'firebase/firestore'
import 'firebase/storage'
// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyDa7KIt3WdwqGeQKUC2PlZfPMaeJYmGNQU",
    authDomain: "tpo-knowledge-jp.firebaseapp.com",
    databaseURL: "https://tpo-knowledge-jp.firebaseio.com",
    projectId: "tpo-knowledge-jp",
    storageBucket: "tpo-knowledge-jp.appspot.com",
    messagingSenderId: "742977842851",
    appId: "1:742977842851:web:80e6642dd0f6a557429916",
    measurementId: "G-GY64PG6BWN"
  };
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export {db,auth,storage};


// const functions = require('firebase-functions');
// const admin = require('firebase-admin')
// admin.initializeApp();
// const db = admin.firestore();

// const algoliasearch = require('algoliasearch');
// const APP_ID = functions.config().algolia.app;
// const ADMIN_KEY = functions.config().algolia.key;
// const client = algoliasearch(APP_ID, ADMIN_KEY);
// const alogia_index = client.initIndex('dev_KAIGO');

// // const Airtable = require('airtable')
// // const base = new Airtable({apiKey:functions.config().airtable.key}).base('appP2yDTQy9rTEVpU');

// const sgMail = require('@sendgrid/mail')
// const sg_API_KEY = functions.config().sendgrid.key;
// const sg_TEMPLATE_ID = functions.config().sendgrid.template;
// sgMail.setApiKey(sg_API_KEY)


// exports.addToIndex = functions.firestore.document('reports/{reportID}').onCreate(snap => {

//     const data = snap.data();
//     const objectID = snap.id;
//     return alogia_index.addObject({ ...data, objectID })
// });

// exports.updateIndex = functions.firestore.document('reports/{reportID}').onUpdate(change => {

//     const data = change.after.data();
//     const objectID = change.after.id;
//     return alogia_index.addObject({ ...data, objectID })
// });

// exports.deleteIndex = functions.firestore.document('reports/{reportID}').onDelete(snap =>
//     alogia_index.deleteObject(snap.id)
// );

// // exports.addReportsToAirtableTextReport = functions.firestore
// //     .document('reports/{reportID}')
// //     .onCreate((snap,context)=>{
// //         const data = snap.data();
// //         data.uid=snap.id
// //         //add data to Airtable text report base
// //         return base('Report').create(data)
// //     });

// // exports.updateReportsToAirtableTextReport = functions.firestore
// //     .document('reports/{reportID}')
// //     .onUpdate((change)=>{
// //         const data = change.after.data();
// //         data.uid=change.after.id
// //         //add data to Airtable text report base
// //         return base('Report').create(data)
// // });

// exports.assignNewTicket = functions.firestore
//     .document('ticket_assigned/{ticket_assignedID}')
//     .onCreate((snap,context)=>{
//         console.log(snap.data())
//         console.log(context)
//         const msg = {
//             to: snap.data().researcherEmails,
//             from: 'noreply@yourconcierge.jp',
//             template_id: sg_TEMPLATE_ID,
//             dynamic_template_data:{
//                 subject:snap.data().ticket_subject,
//                 url: 'https://researcher.yourconcierge.jp',
//                 ticketNumber:snap.data().ticket_number,
//                 deadline:snap.data().deadline,
//                 price:snap.data().price
//             },
//         };
//         return sgMail.sendMultiple(msg)
// });

// exports.newCommentForCompletedTicket = functions.firestore
// .document('ticket_completed/{ticket_assignedID}/comment/{commentID}')
// .onCreate((snap,context)=>{
//     console.log(snap.data())
//     console.log(context)
//     if(snap.data().person_in_charge.includes('tpo')){
//         const msg = {
//             to: snap.data().person_in_charge,
//             from: 'noreply@yourconcierge.jp',
//             template_id: 'd-ef323a9bc28a4e40999825a0e63fe5ee',
//             dynamic_template_data:{
//                 subject:snap.data().ticket_subject,
//                 url: 'https://knowledge.yourconcierge.jp',
//                 ticket_number:snap.data().ticket_number,
//             },
//         }
//     }else{
//         const msg = {
//             to: snap.data().person_in_charge,
//             from: 'noreply@yourconcierge.jp',
//             template_id: 'd-ef323a9bc28a4e40999825a0e63fe5ee',
//             dynamic_template_data:{
//                 subject:snap.data().ticket_subject,
//                 url: 'https://researcher.yourconcierge.jp',
//                 ticket_number:snap.data().ticket_number,
//             }
//         }
//     }
//     return sgMail.sendMultiple(msg)
// })

// // exports.addToIndex = functions.firestore.document('reports/{reportID}').onCreate